<div class="main-div">
    <div class="row ms-0 me-0" id="cargo-insurance">
        <div class="col-xl-6 ps-0 pe-0 arrow-overlap-img">
            <img src="../assets/images/our-services/value-added-services/cargo-insurance.jpg" alt="cargo-insurance" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 bg-img-top">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"><span class="number">01.</span> Cargo Insurance</h2>
                <p class="font-16">We offer competitive rates and a simplified tier structure with fast return of insurance certificates from our offices. All claims are handled directly through us with the insurance provider for a speedy settlement. A single bill is also
                    issued with your insurance cost included on the freight invoice.</p>
                    <!-- <br><br> We do our best to ensure your cargo is handled with the utmost care. However, there are unforeseeable factors beyond our control which is why we provide subsequent and elective protection coverage to all clients. -->
                    <p class="font-16"> To learn more about your insurance options, contact your <a href="javascript:void(0);" routerLink="/contact" class="more-link">local office</a>
                </p>
            </div>
        </div>
    </div>

    <div class="row ms-0 me-0" id="customs-clearance">
        <div class="col-xl-6 ps-0 pe-0 order-2 res-order-1 arrow-overlap-img-top">
            <img src="../assets/images/our-services/value-added-services/customs-clearance.jpg" alt="customs-clearance" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 order-1">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"><span class="number">02.</span> Customs Clearance</h2>
                <p class="font-16">As experts in trade requirements, process, customs and tariff regulations, we can facilitate the movement of your goods in and out of different countries anywhere in the world.
                    <br><br> Contact your <a href="javascript:void(0);" routerLink="/contact" class="more-link">local office</a> for more information.</p>
            </div>
        </div>
    </div>
</div>